import React from 'react';

import sy from '~/styles';
import {Text} from '~/components/controls';
import PropTypes from 'prop-types';

const LessorPhone = ({lessor, type = 'maintenance', style}) => {
  const {phone} = lessor?.sublessor?.phone ? lessor.sublessor : lessor ?? {};
  const number = phone?.[type] || phone?.general;
  const digits = `${number ?? ''}`.replace(/[^\d+]/g, '');

  return (
    <Text
      style={[digits && sy['underline'], style]}
      href={digits ? `tel:${digits}` : undefined}
    >
      {number}
    </Text>
  );
};
LessorPhone.propTypes = {
  lessor: PropTypes.any,
  type: PropTypes.oneOf(['maintenance', 'rental']),
  style: PropTypes.any,
};

export default LessorPhone;
